import React from 'react';
import { footerLinks } from '../data/content';
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-ink-900 px-4 py-8 sm:px-6 sm:py-10" data-id="element-58" data-mp="3geze367ujv27">
      <div className="mx-auto max-w-3xl text-center" data-id="element-59" data-mp="32o4b2ak1486j">
        <p className="text-sm font-extrabold uppercase tracking-[0.2em] text-gold-500" data-id="element-60" data-mp="32pfc42m3b1ty">
          VALUX™
        </p>
        <p className="mt-2 text-[13px] text-neutral-300" data-id="element-61" data-mp="36nd75m2jki59">
          El sistema N°1 para el comerciante argentino.
        </p>

        <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[13px]" data-id="element-62" data-mp="38h2z36jh6hs">
          {footerLinks.map(link => <li key={link.label} data-id="element-63" data-mp="3ldkgncakmqtt">
              <a href={link.href} target={link.href.startsWith('http') ? '_blank' : undefined} rel={link.href.startsWith('http') ? 'noopener noreferrer' : undefined} className="inline-flex items-center gap-1.5 text-neutral-300 transition-colors duration-150 hover:text-gold-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400" data-id="element-64" data-mp="3lgonyijc22op">
                <span aria-hidden="true" data-id="element-65" data-mp="3gctmyhqo8do6">{link.icon}</span>
                {link.label}
              </a>
            </li>)}
        </ul>

        <p className="mt-6 border-t border-white/10 pt-5 text-[11px] text-neutral-600" data-id="element-66" data-mp="3q7llbns2v4k0">
          © 2026 VALUX™ — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}